/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import loadable from '@loadable/component';

const PostsContainer = loadable(() => import('../container'));

const Insert = ({
  config,
  tags,
  postData,
  related,
  isDesktop,
  pageNum,
  insert,
  event,
  mic2020Companies,
  mic2020Regions,
  mic2020Sectors,
  postPromoterArticleText,
  setSecondScrollWasMounted
}) => {
  const cardType = get(postData, 'cardType');
  const containerClassName =
    cardType === 'Sponsored Story'
      ? 'sponsored_article__insert'
      : 'article__insert';

  return (
    <div className={containerClassName}>
      <PostsContainer
        key={get(postData, 'id')}
        posts={[postData]}
        related={related}
        isDesktop={isDesktop}
        pageNum={pageNum}
        config={config}
        mic2020Companies={mic2020Companies}
        mic2020Regions={mic2020Regions}
        mic2020Sectors={mic2020Sectors}
        postPromoterArticleText={postPromoterArticleText}
        event={event}
        tags={tags}
        insert={insert}
        setSecondScrollWasMounted={setSecondScrollWasMounted}
      />
    </div>
  );
};

export default Insert;

Insert.defaultProps = {
  isDesktop: false,
  related: [],
  mic2020Companies: [],
  mic2020Regions: [],
  mic2020Sectors: [],
  postPromoterArticleText: '',
  event: null,
  setSecondScrollWasMounted: undefined
};

Insert.propTypes = {
  config: PropTypes.shape({}).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postData: PropTypes.shape({}).isRequired,
  insert: PropTypes.bool.isRequired,
  pageNum: PropTypes.number.isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  isDesktop: PropTypes.bool,
  mic2020Companies: PropTypes.arrayOf(PropTypes.shape()),
  mic2020Regions: PropTypes.arrayOf(PropTypes.shape()),
  mic2020Sectors: PropTypes.arrayOf(PropTypes.shape()),
  postPromoterArticleText: PropTypes.string,
  event: PropTypes.string,
  setSecondScrollWasMounted: PropTypes.func
};
